import React, { useEffect, useState } from "react";
import Loader from "../../../components/shared/Loader";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateMeta } from "../../../store/actions/metaAction";
import userPlaceholder from "../../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server, { uploadServer } from "../../../api/server";
import axios from "axios";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { handleImage } from "helpers";

const SocialTypesShow = () => {
	const dispatch = useDispatch();
	const { id } = useParams();
	const history = useHistory();

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		getValues,
		reset,
	} = useForm();

	const [loading, setLoading] = useState(false);
	const [pictureImg, setPictureImg] = useState(userPlaceholder);
	const [socialType, setSocialType] = useState({});

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "تعديل نوع فئة",
				breadcrumb: "الفئات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		const res = await server(cookie).get(`/settings/socialTypes/${id}`);
		setSocialType(res?.data?.data?.socialType);
		reset(res?.data?.data?.socialType);
		setPictureImg(handleImage(res?.data?.data?.socialType?.icon));
	};

	// handleMethods
	const submitHandler = async data => {
		setLoading(true);
		try {
			const dataForm = new FormData();
			dataForm.append("file", data.pictureUrl[0]);
			if (data?.pictureUrl?.length > 0) {
				const imageResponse = await uploadServer(cookie).post(
					"/upload",
					dataForm
				);
				data.icon = imageResponse.data.data.file.path;
			}

			const dataResponse = await server(cookie).put(
				`/settings/socialTypes/${id}`,
				data
			);
			reset();
			setPictureImg(userPlaceholder);
			history.push("/social/socialType/index");
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const handlePicture = () => {
		const tempValue = getValues("pictureUrl");
		if (tempValue.length < 1) return;
		const blobUrl = URL?.createObjectURL(tempValue?.[0]);
		setValue("picturePath", blobUrl);
		setPictureImg(blobUrl);
	};

	// watchers
	useEffect(() => {
		onStart();
	}, []);
	const renderError = name =>
		errors?.[name]?.type === "required" && (
			<p className="error-hint text-danger">هذا الحقل مطلوب</p>
		);
	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(submitHandler)}>
				<div className="row">
					<div className="col-md-12">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="nameAr">اسم نوع باللغة العربية</label>
									<input
										type="text"
										name="name"
										id="nameAr"
										{...register("name.ar", {
											required: true,
										})}
									/>
									{renderError(`name`)}
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="nameEn">اسم نوع بالغة الانجليزية</label>
									<input
										type="text"
										name="name"
										id="nameEn"
										{...register("name.en", {
											required: true,
										})}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-12">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="picture">البانر</label>
									<input
										type="file"
										id="picture"
										{...register("pictureUrl", {
											onChange: () => handlePicture(),
										})}
									/>
									{renderError(`pictureUrl`)}

									<img src={pictureImg} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<input
							type="text"
							name=""
							id=""
							style={{ display: "none" }}
							{...register("picturePath")}
						/>
						{renderError(`picturePath`)}

						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default SocialTypesShow;
